import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import DoctorsVideos from "./doctorsVideos";
// import PatientTestimonials from "./patientTestimonials";
import ExternalVideos from "./externalVideos";

import { axiosInstance } from "../../utils/tokenSetCookie";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
import { AxiosError } from "axios";
import { toast } from "react-toastify";


export default function MyVideos() {

  const [plans, setPlans] = useState("doctors_videos");

  const [videos, setVideos] = useState({
    doctor: [
    ]
    ,
    patient_testimonial: [

    ],
    external_link: [
    ]
  });

  console.log("new", videos)

  const planOptions = [
    { id: "doctors_videos", label: "Doctor's Videos" },
    { id: "patient_testimonials", label: "Patient Testimonials" },
    { id: "external_videos", label: "External Videos" },
  ];

  const buttonStyle = (id: string) => ({

    all: 'unset',
    cursor: "pointer",
    fontSize: { xs: "14px", md: "16px" },
    fontWeight: "bold",
    borderBottom: plans === id ? "2px solid #0062f5" : "",
    borderRadius: "5px",
    color: plans === id ? "primary.main" : "black",
    width: { xs: "100px", sm: "140px", md: "180px", lg: "200px" },
    textAlign: "center",

  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `${API_BASE_URL}my-videos/list`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status >= 200 && response.status < 300) {
          setVideos(response.data.data);
          // console.log("API Response:", response.data.data);
        } else {
          // console.error("API Failed:", response.status);
        }
      } catch (error) {
        const err = error as AxiosError;
        toast.error(err?.message ?? "Something went wrong");
      }
    };

    fetchData();
  }, []);



  return (
    <>
      <Box sx={{ padding: { xs: "10px", lg: "30px" }, boxShadow: "0 2px 8px rgba(0,0,0,0.1)", mx: "30px", my: "100px", borderRadius: "12px" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography
            variant="h5"
            sx={{
              //   padding: "20px 24px",
              fontWeight: 600,
              color: "primary.main",
              width: "100%",
              fontSize: { xs: "16px", lg: "20px" },
              display: "inline"
            }}
          >
            My Videos
          </Typography>



          {plans === "external_videos" && (
            <Typography sx={{ color: "gray", fontSize: { xs: "4px", sm: "8px", md: "14px" }, width: "100%", textAlign: "end", fontWeight: "bold" }}>
              <span style={{ color: "red" }}>* </span>Clinical Visuals will not be responsible for the content of external sites.
            </Typography>

          )}
        </Box>

        <Box sx={{ my: "30px", display: "flex", alignItems: "center", gap: "5px" }}>
          <Box sx={{ display: "flex", width: "100%", borderBottom: "1px solid #e5e5e5", gap: "20px" }}>
            {planOptions.map(({ id, label }) => (
              <Button
                variant="text"
                disableRipple
                disableElevation
                key={id}
                id={id}
                sx={buttonStyle(id)}
                onClick={() => setPlans(id)}
              >
                {label}
              </Button>
            ))}
          </Box>
        </Box>

        <Box sx={{ mt: "40px" }}>
          {plans === "doctors_videos" && <DoctorsVideos type="1" data={videos.doctor} setData={(updated: any) => {
            setVideos(prev => ({
              ...prev,
              doctor: typeof updated === 'function' ? updated(prev.doctor) : updated,
            }));
          }} setExternalData={(updated: any) => {
            setVideos(prev => ({
              ...prev,
              external_link: typeof updated === 'function' ? updated(prev.external_link) : updated,
            }));
          }} externalData={videos.external_link} />}

          {plans === "patient_testimonials" && <DoctorsVideos type="2" data={videos.patient_testimonial} setData={(updated: any) => {
            setVideos(prev => ({
              ...prev,
              patient_testimonial: typeof updated === 'function' ? updated(prev.patient_testimonial) : updated,
            }));
          }} setExternalData={(updated: any) => {
            setVideos(prev => ({
              ...prev,
              external_link: typeof updated === 'function' ? updated(prev.external_link) : updated,
            }));
          }} externalData={videos.external_link} />}

          {plans === "external_videos" && <ExternalVideos data={videos.external_link} setData={(updated: any) => {
            setVideos(prev => ({
              ...prev,
              external_link: typeof updated === 'function' ? updated(prev.external_link) : updated,
            }));
          }} />}
        </Box>
      </Box>
    </>

  )
}